module.exports = __webpack_public_path__ + "img/0a7b206.png";